import React, { useState, useEffect } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  useCreateAggregationBySellerMutation,
  useGetCommoditiesStockWiseQuery,
  useGetSellerListByIdQuery,
  useGetQualityParameterQuery,
} from "./ProcurementApiSlice";
import Autocomplete from "@mui/material/Autocomplete";
import {
  TextField,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  IconButton,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Spinner } from "reactstrap";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
// import { Typography } from "@mui/material";
import PageNoData from "features/onboarding/users/farmer/PageNoData";
import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { Tag, Divider, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SkeletonLoader from "./SkeletonLoader";
import NoData from "features/MobileProcurement/NoData";
import RefreshIcon from "@mui/icons-material/Refresh";

const SellCommodity = ({
  user_id,
  activeCard,
  refetchBasicDetails,
  UserData,
  showTab,
}) => {
  const navigate = useNavigate();
  const {
    data: getStockWiseCommodity,refetch:refetchCommodity
  } = useGetCommoditiesStockWiseQuery(user_id, { refetchOnReconnect: true });
  console.log("getStockWiseCommodity", getStockWiseCommodity);
  console.log("showTab", showTab);
  const {
    data: getSellerAllStock,
    refetch:refetchStocks,
  } = useGetSellerListByIdQuery(user_id, { refetchOnReconnect: true });
  const [createAggregation] = useCreateAggregationBySellerMutation();
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [CommodityData, setCommodityData] = useState([]);
  const [addStockData, setAddedStock] = useState({
    price: "",
    quantity: "",
    entity_type: "Seller",
    location: {},
    crop_name: "",
    bag_type: "",
    weight_type: "",
    bag_weight: "",
    weigth_tolerance: "",
    bag_weight_unit: "",
    minimum_quantity: "",
    // type_of_sale: "",
  });
  const [cropIdSelected, setCropIdSelected] = useState("");
  const [crop_code, setCropCode] = useState("");
  const [editedValues, setEditedValues] = useState({}); // Tracks edited values for ranges

  // const [stateId, setStateId] = useState("");
  // const [districtId, setDistrictId] = useState("");
  // const [pagination, setPagination] = useState({ page: 1, per_page: 10 });

  // const { data: getStates } = useGetStatesQuery();
  // const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  // const { data: dataBlock } = useGetBlockByDistrictQuery(districtId);
  const { data: qualityRanges } = useGetQualityParameterQuery(crop_code, {
    skip: !crop_code,
  });

  // const [stateList, setStateList] = useState([]);
  // const [districtList, setDistrictList] = useState([]);
  // const [blockList, setBlockList] = useState([]);
  const [QualityRanges, setQualityRanges] = useState([]);

  const [stockData, setStocksData] = useState([]);
  const [loading, setloading] = useState(false);
  const [tableLoader, setTableLoader] = useState(true);

  // const [PincodeValue, setPincode] = useState("");
  const [widthShow, setWidth] = useState(false);
  // const [PincodeDataList, setPincodeDataList] = useState({
  //   State: "",
  //   District: "",
  //   Block: "",
  // });
  // const [pincodeError, setPinCodeError] = useState(false);
  const [updatedPriceValue, setUpdatedPriceValue] = useState("");
  const BagType = [
    { title: "Jute", year: 1990 },
    { title: "PP", year: 1991 },
  ];
  const BagWeight = [
    { title: "Net", year: 1990 },
    { title: "Gross", year: 1991 },
  ];
  const WeightUnit = [
    { title: "KG", year: 1990 },
    { title: "Gram", year: 1991 },
  ];
  const SaleType = [
    { title: "Partial", year: 1990 },
    { title: "Complete", year: 1991 },
  ];

  const [treeData, setTreeData] = useState([]);
  const [stateResponse, setStateResponse] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [showError, setError] = useState(false);
  const [othersValue, setOthersValue] = useState(""); // State to store 'Others' input

  useEffect(() => {
    if (qualityRanges?.data) {
      setQualityRanges(qualityRanges?.data);
      if (crop_code) {
        setTreeData(qualityRanges?.data);
        setSelectedFields([]);
      } else {
        setTreeData([]);
        setSelectedFields([]);
      }
    }
  }, [qualityRanges, activeCard]);
  // useEffect(()=>{
  // refetchCommodity()
  // },[])
  useEffect(() => {
    if (getStockWiseCommodity) {
      setCommodityData(getStockWiseCommodity?.data);
      if (getSellerAllStock) {
        setTableLoader(false);
        setStocksData(getSellerAllStock?.data?.results);
      }
    }
  }, [getStockWiseCommodity, getSellerAllStock]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (addStockData.type_of_sale === "Complete") {
      if (addStockData.quantity != cropIdSelected.quantity) {
        setError(true);
        return;
      }
    }

    setloading(true);
    // const response = selectedFields?.map((field) => {
    //   return {
    //     range: field.range,
    //     fields: field.fields,
    //   };
    // });
    let payload = {
      ...addStockData,
      crop_code: cropIdSelected?.crop_id,
      created_by: RolesFromToken.organization_id,
      // StateName: cropIdSelected.state,
      // DistrictName: cropIdSelected.district,
      // BlockName: cropIdSelected.block,
      unit_of_measure: cropIdSelected?.unit_measurement,
      quality_parameters: {
        parameters: stateResponse.length > 0 ? stateResponse : [],
      },

      minimum_quantity:
        addStockData.minimum_quantity === ""
          ? 0
          : parseInt(addStockData.minimum_quantity),
      // address: cropIdSelected.address,
      // pincode:cropIdSelected.pincode
    };
    // console.log("payload", payload);
    createAggregation(payload)
      .unwrap()
      .then((data) => {
        toast.success("Trade Created Successfully.Wait for Admin Approval !!");
        setloading(false);

        setUpdatedPriceValue("");
        setError(false);

        setAddedStock({
          price: "",
          quantity: "",
          entity_type: "Seller",
          location: {},
          address: "",
          crop_name: "",
          bag_type: "",
          weight_type: "",
          bag_weight: "",
          weigth_tolerance: "",
          quality_parameters: {},
          bag_weight_unit: "",
          type_of_sale: "",
          minimum_quantity: "",
        });
        setCropIdSelected("");
        setCropCode("");
        setTreeData([]);
        setStateResponse([]);
        setSelectedFields([]);
        setOthersValue("");
        refetchStocks();
      })
      .catch((error) => {
        // console.log("error", error);
        toast.error(error.data.message);
        setloading(false);

        return;
      });
  };
  const handleChange = (name) => (e, value) => {
    if (name === "crop_name") {
      const filteredData = CommodityData?.find(
        (item) => item.crop_name === value
      );
      setCropIdSelected(filteredData);
      setCropCode(filteredData.crop_id);
      setAddedStock({
        ...addStockData,
        [name]: value,
        quantity: filteredData.quantity,
        price: filteredData.price,
      });
      setUpdatedPriceValue(filteredData.price * filteredData.quantity);
    } else if (
      name === "bag_type" ||
      name === "weight_type" ||
      name === "bag_weight_unit" ||
      name === "type_of_sale"
    ) {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else {
      setAddedStock({
        ...addStockData,
        [e.target.name]: e.target.value,
      });
    }
    if (name === "quantity") {
      setUpdatedPriceValue(addStockData.price * e.target.value);
    }
  };

  // const columns = [
  //   {
  //     field: "crop_name",
  //     headerName: "Commodity",
  //     width: 200,
  //     renderCell: (cellvalues) => {
  //       return <div className="mx-3">{cellvalues?.row?.crop_name}</div>;
  //     },
  //   },

  //   {
  //     field: "quantity",
  //     headerName: "Quantity",
  //     width: 180,
  //     renderCell: (cellvalues) => {
  //       return (
  //         <div className="text-center">
  //           {cellvalues?.row?.quantity}{" "}
  //           {cellvalues?.row?.unit_of_measure === "Quintal"
  //             ? "Qtl."
  //             : cellvalues?.row?.unit_of_measure === "Metric Tonne"
  //             ? "MT"
  //             : cellvalues?.row?.unit_of_measure}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "price",
  //     headerName: "Total Price (₹)",
  //     width: 180,
  //     renderCell: (cellvalues) => {
  //       // Calculate the total price
  //       const totalPrice = cellvalues?.row?.price * cellvalues?.row?.quantity;
  //       return (
  //         <div style={{ display: "flex", flexDirection: "column" }}>
  //           {totalPrice !== undefined && (
  //             <Typography variant="body1">{totalPrice}</Typography>
  //           )}
  //           <Typography variant="body2">
  //             <span className="text-blue f300 ">
  //               Price/Unit : ₹{cellvalues?.row?.price}
  //             </span>
  //           </Typography>
  //         </div>
  //       );
  //     },
  //   },

  //   { field: "address", headerName: "Stock Location", width: 200 },

  //   {
  //     field: "is_approved",
  //     headerName: "Verification Status",
  //     width: 200,
  //     renderCell: (cellvalues) => {
  //       return (
  //         <>
  //           <div>
  //             {cellvalues?.row?.is_approved === true ? (
  //              <Tag bordered={false} color="green">
  //              Done
  //            </Tag>
  //             ) : (
  //               <Tag bordered={false} color="geekblue">
  //                 Pending
  //                   </Tag>
  //             )}
  //           </div>
  //         </>
  //       );
  //     },
  //   },
  // ];
  // const tableData = {
  //   rows: stockData,
  //   columns: columns,
  //   paginationState: [pagination, setPagination],
  //   isLoading: isLoading,
  //   checkboxShowFalse: true,
  // };
  const handleClass = () => {
    if (widthShow) return "col-md-5";
    else return "col-md-12 ";
  };

  const handleCheckboxChange = (item) => {
    if (item === "Others") {
      setSelectedFields((prevFields) => {
        const othersIndex = prevFields.findIndex(
          (field) => field.fields === "Others"
        );

        if (othersIndex !== -1) {
          return prevFields.filter((field) => field.fields !== "Others");
        } else {
          return [
            ...prevFields,
            { fields: "Others", range: { range_one: "", edited_key: "" } },
          ];
        }
      });
    } else {
      setSelectedFields((prevFields) => {
        const isSelected = prevFields.some(
          (field) => field.fields === item.fields
        );
        if (isSelected) {
          return prevFields.filter((field) => field.fields !== item.fields);
        } else {
          return [...prevFields, item];
        }
      });
    }
  };

  const handleRadioChange = (field, rangeKey) => {
    setEditedValues((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        selectedRange: rangeKey,
      },
    }));
  };

  const handleInputChange = (field, rangeKey, newValue) => {
    setEditedValues((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [rangeKey]: newValue,
      },
    }));
  };

  useEffect(() => {
    const response = selectedFields.map((field) => {
      const fieldName = field.fields;

      const treeDataField = treeData.find((item) => item.fields === fieldName);

      const editedField = editedValues[fieldName] || {};

      const range = {};
      const selectedKey =
        editedField.selectedRange || treeDataField?.selected_key || "";

      if (fieldName === "Others") {
        range["range_one"] =
          editedField["range_one"] || treeDataField?.range?.range_one || "";
        range["edited_key"] = editedField["edited_key"] || "";
      } else {
        if (selectedKey && treeDataField[selectedKey]) {
          range[selectedKey] = treeDataField[selectedKey];
        }
        range["edited_key"] = editedField[selectedKey] || "";
      }

      return {
        fields: fieldName,
        range,
      };
    });

    setStateResponse(response);
  }, [selectedFields, editedValues, treeData]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  // const handleDropdownToggleTemplate = () => {
  //   setIsDropdownOpen(false);
  // };
  useEffect(() => {
    const response = selectedFields?.map((field) => {
      return {
        range: field.range,
        fields: field.fields,
      };
    });
    setStateResponse(response);
  }, [selectedFields]);
  const handleOthersInputChange = (e) => {
    const value = e.target.value;
    setOthersValue(value);

    // Update the selectedFields array
    setSelectedFields((prevFields) => {
      // Check if "Others" is already in the selected fields
      const existingIndex = prevFields.findIndex((f) => f.fields === "Others");

      // If "Others" is selected, update it; else, add it
      if (existingIndex !== -1) {
        // Update the existing "Others" entry
        prevFields[existingIndex].range = { range_one: value, edited_key: "" };
      } else {
        // Add the new "Others" entry
        prevFields.push({
          fields: "Others",
          range: { range_one: value, edited_key: "" },
        });
      }

      return [...prevFields]; // Ensure we return a new array reference
    });
  };
  return (
    <>
      <div className="d-flex justify-content-end mb-2 mx-2">
        {widthShow ? (
          <b
            onClick={() => setWidth(false)}
            className="cursor-pointer mt-3 "
            style={{
              color: "#1976D2",
              fontSize: "14px",
              // float: "right",
            }}
          >
            Back to List &nbsp;
            <FontAwesomeIcon icon={faRotateLeft} />
          </b>
        ) : UserData.is_verified ? (
          <Button
            variant="contained"
            className="buttonOrangeDefaultColor mt-3"
            style={{ float: "right" }}
            onClick={() => {
              setWidth(true);
            }}
          >
            {" "}
            <AddIcon /> Initiate Trade
          </Button>
        ) : (
          <Button
            variant="contained"
            // style={{float: "right",
            // }}
            className=" buttonOrangeDefaultColor mt-3"
            onClick={() =>
              Swal.fire({
                title: `Your Profile is not Verified. First Complete Documents`,
                text: `Proceed to Profile For Document Submission`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Continue",
                cancelButtonText: "Cancel",
                confirmButtonIcon: "fas fa-arrow-right", // Add the icon you want here
              }).then((result) => {
                if (result.isConfirmed) {
                  // setActiveCard("Buyer Cart");
                  navigate(`/completeProfile/${user_id}`);
                } else {
                }
              })
            }
          >
            <AddIcon /> Initiate Trade
          </Button>
        )}
      </div>

      <div className=" row">
        <div className={handleClass()}>
          {tableLoader ? (
            <div className="">
              <SkeletonLoader />
            </div>
          ) : stockData?.length > 0 ? (
            <Grid container spacing={2} className="content">
              {stockData?.map((row, index) => (
                <Grid item xs={12} sm={6} md={widthShow ? 6 : 4} key={index}>
                  <Card
                    variant="outlined"
                    sx={{
                      padding: 2,
                      borderRadius: "12px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s",
                      "&:hover": { transform: "scale(1.02)" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { sm: "row" },
                        alignItems: { xs: "center", sm: "flex-start" },
                        marginBottom: 1.5,
                      }}
                    >
                      {row.image_url && (
                        <Box
                          component="img"
                          src={row.image_url}
                          alt={row.crop_name}
                          sx={{
                            width: "70px",
                            height: "70px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginBottom: { xs: 1, sm: 0 },
                            marginRight: { sm: 2 },
                          }}
                        />
                      )}

                      <Box
                        sx={{
                          flex: 1,
                          textAlign: { xs: "center", sm: "left" },
                        }}
                      >
                        <Typography variant="h6">
                          {row.crop_name.replace(/_/g, " ")}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "text.secondary" }}
                        >
                          Created: {row.created_at.slice(0, 10)}
                        </Typography>
                      </Box>
                    </Box>

                    <CardContent sx={{ padding: 0 }}>
                      {/* Quantity and Price */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: { sm: "row" },
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Quantity:{" "}
                          <strong>
                            {row.quantity} {row.unit_of_measure}
                          </strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Price/Unit: <strong> ₹ {row.price}</strong>
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",

                          flexWrap: { xs: "wrap", sm: "nowrap" },
                        }}
                        className="mt-1"
                      >
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 500, color: "#69829f" }}
                        >
                          Verification Status:{" "}
                          <div>
                            {row?.is_approved === true ? (
                              <Tag
                                icon={<CheckCircleOutlined />}
                                color="success"
                              >
                                Done
                              </Tag>
                            ) : (
                              <Tag
                                icon={<ClockCircleOutlined />}
                                color="warning"
                              >
                                Pending
                              </Tag>
                            )}
                          </div>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 500, color: "primary.main" }}
                        >
                          Total: ₹ {row.quantity * row.price}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <NoData val="Trade" />
          )}
        </div>
        {widthShow ? (
          <div id="initiate-trade-section" className="col-md-7">
            <div className="card22 border_right ">
              <div className="">
                <h3 className="text-gray text-center mt-3 text-black">
                  {" "}
                  Initiate Trade{" "}
                </h3>
                <form
                  onSubmit={handleSubmit}
                  className="form-submit mb-2 mt-1 p-2"
                >
                  <div className="row">
                    <div className="col-lg-4 col-12 MuiTextArea mb-3">
                      {/* <Autocomplete
                          id="free-solo-2-demo"
                          name="crop_name"
                          disableClearable
                          options={CommodityData?.map(
                            (option) => option.crop_name
                          )}
                          onChange={handleChange("crop_name")}
                          value={addStockData.crop_name}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Commodity"
                              InputLabelProps={{ shrink: true }} 
                              required
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                              
                              }}
                            />
                          )}
                        /> */}

                      <Autocomplete
                        id="free-solo-2-demo"
                        name="crop_name"
                        disableClearable
                        options={CommodityData?.map(
                          (option) => option.crop_name
                        )}
                        onChange={handleChange("crop_name")}
                        value={addStockData.crop_name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Commodity"
                            InputLabelProps={{ shrink: true }}
                            required
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton size="small" onClick={() => {refetchCommodity()}}>
                                    <RefreshIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-lg-4 col-12 MuiTextArea mb-3">
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Quantity"
                        name="quantity"
                        required
                        multiline
                        maxRows={2}
                        onChange={handleChange("quantity")}
                        style={{ width: "100%" }}
                        value={addStockData.quantity}
                        onKeyPress={(event) => {
                          // Add this prop
                          if (!/\d/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        maxLength={addStockData.quantity}
                        InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                        className="mx-1"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end"></InputAdornment>
                          ),
                        }}
                      />
                      {cropIdSelected ? (
                        <b
                          className="float-end mt-1 m-0 textBlue"
                          style={{ fontSize: "12px" }}
                        >
                          Available Quantity:&nbsp;{cropIdSelected?.quantity}{" "}
                          {cropIdSelected?.unit_measurement === "Metric Tonne"
                            ? "MT"
                            : cropIdSelected?.unit_measurement}
                        </b>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-lg-4 col-12 MuiTextArea mb-3">
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Price (₹)"
                        name="price"
                        onChange={handleChange("price")}
                        required
                        disabled
                        className=""
                        multiline
                        value={updatedPriceValue}
                        maxRows={2}
                        style={{ width: "100%" }}
                        InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                      />
                      {cropIdSelected ? (
                        <b
                          className="float-end mt-1 m-0 textBlue"
                          style={{ fontSize: "12px" }}
                        >
                          Price/
                          {cropIdSelected?.unit_measurement === "Metric Tonne"
                            ? "MT"
                            : cropIdSelected?.unit_measurement}
                          :&nbsp; ₹ {cropIdSelected?.price}
                        </b>
                      ) : (
                        ""
                      )}
                    </div>

                    <h6
                      className=" mt-2 text-successs mx-2"
                      style={{ fontSize: "10px" }}
                    >
                      NOTE : Quantity should be less then or equal to Available
                      quantity.{" "}
                    </h6>

                    <div className="col-lg-12 col-12 mt-3 ">
                      <h6 className=" mt-2 text-gray mx-2">
                        Choose Quality Parameters :{" "}
                      </h6>
                      <div
                        className="dropdown-nested text-center cursor-pointer"
                        onClick={handleDropdownToggle}
                        style={{ width: "98%" }}
                      >
                        {" "}
                        Select Parameters <ArrowDropDownIcon className="f400" />
                      </div>

                      <div
                        className={`dropdown-menu dropdown-nested ${
                          isDropdownOpen ? "show" : ""
                        }`}
                        style={{
                          width: "53%",
                          zIndex: "100",
                          backgroundColor: "white",
                          boxShadow: "0px 0px 11px 3px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        {treeData?.map((item) => (
                          <div
                            key={item.fields}
                            className="item-nested mx-3 p-2"
                          >
                            <input
                              type="checkbox"
                              checked={selectedFields.some(
                                (field) => field.fields === item.fields
                              )}
                              onChange={() => handleCheckboxChange(item)}
                            />
                            <span className="mx-2">{item.fields}</span>
                            {selectedFields?.some(
                              (field) => field.fields === item.fields
                            ) && (
                              <div className="mx-3 mt-2">
                                <h6>Values:</h6>
                                <div className="ranges">
                                  {Object.entries(item)
                                    .filter(([key]) => key.startsWith("range_"))
                                    .map(([rangeKey, rangeValue]) => (
                                      <div
                                        key={rangeKey}
                                        className="range-item"
                                      >
                                        <input
                                          type="radio"
                                          name={item.fields}
                                          value={rangeValue}
                                          checked={
                                            editedValues[item.fields]
                                              ?.selectedRange === rangeKey
                                          }
                                          onChange={() =>
                                            handleRadioChange(
                                              item.fields,
                                              rangeKey
                                            )
                                          }
                                        />
                                        <input
                                          type="text"
                                          disabled={
                                            editedValues[item.fields]
                                              ?.selectedRange !== rangeKey
                                          }
                                          defaultValue={
                                            editedValues[item.fields]?.[
                                              rangeKey
                                            ] || rangeValue
                                          }
                                          onChange={(e) =>
                                            handleInputChange(
                                              item.fields,
                                              rangeKey,
                                              e.target.value
                                            )
                                          }
                                          style={{
                                            width: "40%",
                                            padding: "2px",
                                          }}
                                        />
                                      </div>
                                    ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}

                        <div className="mx-4">
                          <input
                            type="checkbox"
                            checked={selectedFields?.some(
                              (field) => field.fields === "Others"
                            )}
                            onChange={() =>
                              handleCheckboxChange({ fields: "Others" })
                            }
                          />
                          <label className="mx-1">Others</label>
                          {selectedFields.some(
                            (field) => field.fields === "Others"
                          ) && (
                            <TextField
                              id="outlined-multiline-flexible"
                              name="Others"
                              value={othersValue}
                              onChange={handleOthersInputChange}
                              required
                              className="mt-5 mx-1"
                              size="small"
                              style={{ width: "40%" }}
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        </div>
                      </div>
                      {stateResponse?.length > 0 && (
                        <div className="flex-grow-1 text-right parametersClass">
                          <ul className="">
                            {stateResponse?.map((field, index) => (
                              <li key={index}>
                                {field.fields},
                                {field?.range &&
                                  Object.keys(field?.range).length > 0 && (
                                    <span className="mx-2">
                                      {field.range.edited_key !== ""
                                        ? field.range.edited_key
                                        : field.range.range_two ||
                                          field.range.range_one ||
                                          field.range.range_three ||
                                          ""}
                                    </span>
                                  )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    <div className="col-lg-4 MuiTextArea">
                      <Autocomplete
                        id="free-solo-2-demo"
                        name="weight_type"
                        className="mt-4"
                        disableClearable
                        value={addStockData.weight_type}
                        onChange={handleChange("weight_type")}
                        options={BagWeight?.map((option) => option.title)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Weight Type"
                            InputLabelProps={{ shrink: true }}
                            required
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-lg-4 MuiTextArea">
                      <Autocomplete
                        id="free-solo-2-demo"
                        name="bag_type"
                        className="mt-4"
                        disableClearable
                        value={addStockData.bag_type}
                        onChange={handleChange("bag_type")}
                        options={BagType?.map((option) => option.title)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Bag Type"
                            InputLabelProps={{ shrink: true }}
                            required
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                          />
                        )}
                      />
                    </div>

                    {addStockData.weight_type == "Net" && (
                      <>
                        <div className="col-lg-4 MuiTextArea">
                          <TextField
                            id="outlined-multiline-flexible"
                            label="Bag Weight"
                            name="bag_weight"
                            onChange={handleChange("bag_weight")}
                            value={addStockData.bag_weight}
                            required
                            className="mt-4"
                            multiline
                            maxRows={2}
                            style={{ width: "100%", zIndex: 0 }}
                            InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                          />
                        </div>
                        <div className="col-lg-4 MuiTextArea">
                          <Autocomplete
                            id="free-solo-2-demo"
                            name="bag_weight_unit"
                            className="mt-4"
                            disableClearable
                            value={addStockData.bag_weight_unit}
                            onChange={handleChange("bag_weight_unit")}
                            options={WeightUnit?.map((option) => option.title)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Weight Unit"
                                InputLabelProps={{ shrink: true }}
                                required
                                InputProps={{
                                  ...params.InputProps,
                                  type: "search",
                                }}
                              />
                            )}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-lg-4 MuiTextArea">
                      <TextField
                        id="outlined-multiline-flexible"
                        label="Weight Tolerance (-5 to +5)"
                        name="weigth_tolerance"
                        // onChange={handleChange("weigth_tolerance")}
                        value={addStockData.weigth_tolerance}
                        required
                        className="mt-4"
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const parsedValue = parseFloat(inputValue);

                          if (
                            inputValue === "" ||
                            inputValue === "-" ||
                            (!isNaN(parsedValue) &&
                              parsedValue >= -5 &&
                              parsedValue <= 5)
                          ) {
                            handleChange("weigth_tolerance")(e);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        multiline
                        maxRows={2}
                        style={{ width: "100%", zIndex: 0 }}
                        InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                      />
                    </div>

                    <div className="col-lg-4 MuiTextArea">
                      <TextField
                        id="free-solo-2-demo"
                        type="number"
                        label="Minimum Lot Size (Qty)"
                        name="minimum_quantity"
                        className="mt-4"
                        value={addStockData.minimum_quantity}
                        onChange={handleChange("minimum_quantity")}
                        style={{ width: "100%", zIndex: 0 }}
                        InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                      />
                    </div>

                    {/* <div className="col-lg-8 MuiTextArea">
                        <TextField
                          id="outlined-multiline-flexible"
                          label="Stock Location"
                          name="address"
                          onChange={handleChange("address")}
                          value={
                            cropIdSelected.district
                              ? cropIdSelected.district +
                                ", " +
                                cropIdSelected.state +
                                " ," +
                                cropIdSelected.pincode
                              : ""
                          }
                          required
                          disabled
                          className="mt-4"
                          multiline
                          maxRows={2}
                          style={{ width: "100%", zIndex: 0 }}
                          InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                        />
                      </div>  */}
                  </div>
                  {/* {showError && (
                      <p className="text-danger">
                        NOTE: Please select Full Quantity as Type of Sale is
                        Completed
                      </p>
                    )} */}

                  <Divider orientation="right">
                    <Button
                      variant="contained"
                      className="text-center"
                      color="success"
                      size="small"
                      type="submit"
                    >
                      Submit &nbsp; {loading ? <Spinner size="sm" /> : ""}
                    </Button>
                  </Divider>
                </form>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default SellCommodity;
